const styles = {
  paper: { borderRadius: 3, maxWidth: 400 },
  icon: {
    width: 48,
    height: 48,
    borderRadius: "50%",
    backgroundColor: "#f0fdf4",
    color: "#008236",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mx: "auto",
    mb: 2,
    fontSize: 20,
  },
  title: { fontSize: 18, fontWeight: 600, color: "#0a0a0a", mb: 1 },
  body: { fontSize: 14, color: "#717182", lineHeight: 1.5 },
  button: {
    textTransform: "none",
    fontWeight: 500,
    borderRadius: 2,
    px: 3,
    boxShadow: "none",
  },
};

export default styles;
